<template>
  <b-modal
    ref="petitionerModal"
    size="xxl"
    centered
    modal-class="configuration-modal-tabs petitioner-modal"
    static
    hide-footer
    @hidden="hide"
  >
    <div slot="modal-title">
      {{ actionTitle }} <span style="text-transform: lowercase">{{ $tc('configuration.sections.petitioners', 1) }}</span>
    </div>
    <b-row class="px-0">
      <b-col class="px-2 pt-1 pb-2">
        <div>
          <b-tabs
            v-model="activeTabIndex"
            pills
            card
            vertical
            class="vt-tabs--pills"
          >
            <b-tab active>
              <template slot="title">
                <i
                  class="far fa-list-ul mr-2"
                  aria-hidden="true"
                />
                {{ $t('configuration.modal.basicData') }}
              </template>
              <b-row
                style=""
                class="scroll-area px-1 pt-1 pb-3"
              >
                <b-col class="mt-3">
                  <b-row>
                    <b-col>
                      <div class="form-card">
                        <span class="ap-title ap-title__section"><i
                          class="far fa-user mr-2 mb-2"
                          aria-hidden="true"
                        />{{ $t('configuration.modal.petitioner.petitionerData') }}</span>
                        <b-row class="mt-2">
                          <b-col
                            cols="4"
                            class="mb-3"
                          >
                            <b-form-group
                              :label="`${$tc('configuration.grid.externalCode')}`"
                              :state="!errors.has($tc('configuration.grid.externalCode'))"
                              :invalid-feedback="errors.first($tc('configuration.grid.externalCode'))"
                            >
                              <vt-input
                                ref="code"
                                v-model="internalPetitioner.code"
                                v-validate="'required'"
                                :name="$tc('configuration.grid.externalCode')"
                                :class="{'is-invalid': errors.has($tc('configuration.grid.externalCode'))}"
                                class="form-control-sm"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col
                            cols="4"
                            class="mb-3"
                          >
                            <b-form-group
                              :label="`${$tc('configuration.grid.name')}`"
                              :state="!errors.has($tc('configuration.grid.name'))"
                              :invalid-feedback="errors.first($tc('configuration.grid.name'))"
                            >
                              <vt-input
                                v-model="internalPetitioner.name"
                                v-validate="'required'"
                                :name="$tc('configuration.grid.name')"
                                :class="{'is-invalid': errors.has($tc('configuration.grid.name'))}"
                                class="form-control-sm"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col
                            v-if="globalParameters.middleNameSupported"
                            cols="4"
                            class="mb-3"
                          >
                            <div class="form-label">
                              <label>{{ $t('configuration.grid.middleName') }}</label>
                            </div>
                            <vt-input
                              v-model="internalPetitioner.middleName"
                              v-validate
                              class="form-control-sm"
                            />
                          </b-col>
                          <b-col
                            cols="4"
                            class="mb-3"
                          >
                            <b-form-group
                              :label="`${$tc('configuration.grid.surname1')}`"
                              :state="!errors.has($tc('configuration.grid.surname1'))"
                              :invalid-feedback="errors.first($tc('configuration.grid.surname1'))"
                            >
                              <vt-input
                                v-model="internalPetitioner.surname1"
                                v-validate="'required'"
                                :name="$tc('configuration.grid.surname1')"
                                class="form-control-sm"
                                :class="{'is-invalid': errors.has($tc('configuration.grid.surname1')) }"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col
                            cols="4"
                            class="mb-3"
                          >
                            <div class="form-label">
                              <label>{{ $t('configuration.grid.surname2') }}</label>
                            </div>
                            <vt-input
                              v-model="internalPetitioner.surname2"
                              :name="$tc('configuration.grid.surname2')"
                              class="form-control-sm"
                            />
                          </b-col>
                          <b-col
                            cols="4"
                            class="mb-3 d-flex align-items-center justify-content-end"
                          >
                            <div class="switch-btn mt-1 p-0 d-flex align-items-center">
                              <span class="mr-2">{{ $t('configuration.grid.physician') }}</span>
                              <input
                                id="toggle-physician"
                                v-model="internalPetitioner.isPhysician"
                                v-validate
                                :name="$tc('configuration.grid.physician')"
                                type="checkbox"
                                class="offscreen"
                                aria-hidden="true"
                              >
                              <label
                                for="toggle-physician"
                                class="switch mb-0"
                              />
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3 mb-2">
                    <b-col>
                      <div class="form-card">
                        <span class="ap-title ap-title__section"><i
                          class="far fa-envelope mr-2 mb-2"
                          aria-hidden="true"
                        />{{ $t('configuration.modal.contactAndNotifications') }}</span>
                        <b-row class="mt-2">
                          <b-col
                            cols="6"
                            class="mb-3"
                          >
                            <div class="form-label">
                              <label>{{ $t('configuration.grid.email') }}</label>
                            </div>
                            <vt-input
                              v-model="internalPetitioner.contactInformation.email"
                              v-validate
                              :name="$tc('configuration.grid.email')"
                              class="form-control-sm"
                            />
                          </b-col>
                          <b-col
                            cols="6"
                            class="mb-3 d-flex align-items-center justify-content-end"
                          >
                            <div class="switch-btn mt-1 p-0 d-flex align-items-center">
                              <span class="mr-2">{{ $t('configuration.modal.emailNotifications') }}</span>
                              <input
                                id="toggle-email"
                                v-model="internalPetitioner.contactInformation.emailNotificationEnabled"
                                v-validate
                                :disabled="!petitionerEmail"
                                :name="$tc('configuration.modal.emailNotifications')"
                                type="checkbox"
                                class="offscreen"
                                aria-hidden="true"
                              >
                              <label
                                :class="{ 'disabled' : !petitionerEmail }"
                                for="toggle-email"
                                class="switch mb-0"
                              />
                            </div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col
                            cols="6"
                            class="mb-3"
                          >
                            <div class="form-label">
                              <label>{{ $t('configuration.grid.phone') }}</label>
                            </div>
                            <vt-input
                              v-model="internalPetitioner.contactInformation.mainPhone"
                              v-validate
                              :name="$tc('configuration.grid.phone')"
                              class="form-control-sm"
                            />
                          </b-col>
                          <b-col
                            cols="6"
                            class="mb-3 d-flex align-items-center justify-content-end"
                          >
                            <div class="switch-btn mt-1 p-0 d-flex align-items-center">
                              <span class="mr-2">{{ $t('configuration.modal.smsNotifications') }}</span>
                              <input
                                id="toggle-sms"
                                v-model="internalPetitioner.contactInformation.smsNotificationEnabled"
                                v-validate
                                :disabled="!petitionerMainPhone"
                                :name="$t('configuration.modal.smsNotifications')"
                                type="checkbox"
                                class="offscreen"
                                aria-hidden="true"
                              >
                              <label
                                for="toggle-sms"
                                :class="{ 'disabled' : !petitionerMainPhone }"
                                class="switch mb-0"
                              />
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col
                      cols="12"
                      class="my-1 d-flex justify-content-end"
                    >
                      <div class="switch-btn mt-1 p-0 d-flex align-items-center">
                        <span
                          v-if="internalPetitioner.active"
                          class="mr-2"
                        >{{ $t('configuration.actions.active') }}</span>
                        <span
                          v-else
                          class="mr-2"
                        >{{ $t('configuration.actions.inactive') }}</span>
                        <input
                          id="toggle"
                          v-model="internalPetitioner.active"
                          v-validate
                          :name="`${$t('configuration.actions.active')}${$tc('configuration.actions.inactive')}`"
                          type="checkbox"
                          class="offscreen"
                          aria-hidden="true"
                        >
                        <label
                          for="toggle"
                          class="switch mb-0"
                        />
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <div class="footer-area component-bg d-flex justify-content-between px-3 py-2 align-items-center">
                <div>
                  <b-button
                    :disabled="!internalPetitioner.id"
                    :to="{ name: 'PeopleUserapp', params: { actions: getActions(internalPetitioner) } }"
                    class="btn__link"
                  >
                    <span>{{ $t('configuration.modal.goToUser') }}</span>
                  </b-button>
                </div>
                <div>
                  <b-button
                    :disabled="!modelValidated"
                    size="sm"
                    class="btn--primary"
                    @click="update"
                  >
                    <i
                      class="fal fa-check mr-2"
                      aria-hidden="true"
                    />
                    {{ actionTitle }}
                  </b-button>
                </div>
              </div>
            </b-tab>
            <b-tab :disabled="!internalPetitioner.id">
              <template slot="title">
                <i
                  class="far fa-clinic-medical mr-2"
                  aria-hidden="true"
                />
                {{ $tc('configuration.sections.department', 2) }}
              </template>
              <div class="sticky-area pb-2">
                <b-row class="p-3">
                  <b-col cols="12">
                    <span class="title">{{ $tc('configuration.sections.department', 2) }}</span>
                  </b-col>
                </b-row>
                <b-row class="px-3 mb-2">
                  <b-col cols="12">
                    <b-row>
                      <b-col class="pr-1">
                        <div class="form-label">
                          <label>{{ $t('component.studyRequest.form.clinicCard.physicianCenter') }}</label>
                        </div>
                        <vt-combo-select
                          ref="centersSelect"
                          v-model="selectedCenter"
                          qa="configuration-protocols-modal-petitionerDepartmentCenter-select"
                          class="nowrap"
                          ajax-search
                          :internal-search="false"
                          :option-loader="getCenters"
                          :allow-empty="false"
                          label="name"
                          @input="cleanDepartmentsSelect"
                        />
                      </b-col>
                      <b-col class="pr-1">
                        <div class="form-label">
                          <label>{{ $tc('configuration.sections.department', 1) }}</label>
                        </div>
                        <vt-combo-select
                          ref="departmentsSelect"
                          v-model="selectedDepartment"
                          qa="configuration-protocols-modal-petitionerDepartment-select"
                          class="nowrap"
                          :disabled="!selectedCenter"
                          :option-loader="getDepartmentsByCenter"
                          ajax-search
                          :internal-search="false"
                          :allow-empty="false"
                          label="name"
                        />
                      </b-col>
                      <b-col
                        cols="auto"
                        class="d-flex flex-column justify-content-end pl-1"
                      >
                        <b-button
                          qa="configuration-protocols-modal-add-petitionerDepartment-button"
                          :disabled="!selectedDepartment"
                          class="d-flex align-items-center justify-content-center btn--primary ml-2 p-2"
                          size="sm"
                          @click="addPetitionerDepartment"
                        >
                          <i
                            class="fal fa-plus"
                            aria-hidden="true"
                          />
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
              <b-row class="px-3 my-2">
                <b-col
                  v-if="!petitionerDepartments.length"
                  cols="12"
                  class="py-3 petitioner-departments-empty-state"
                >
                  <i
                    class="fal fa-empty-set mr-2"
                    aria-hidden="true"
                  />
                  <span>{{ $t('configuration.modal.noAssociatedElement') }}</span>
                </b-col>
                <b-col
                  v-else
                  cols="12"
                  class="pb-3 pt-0 px-4"
                >
                  <b-row
                    v-for="(petitionerDepartment, index) in petitionerDepartments"
                    :key="index"
                    class="custom-table-row bottom-bordered"
                  >
                    <b-col>
                      <span>{{ petitionerDepartment.department.center.name }}</span>
                    </b-col>
                    <b-col>
                      <span>{{ petitionerDepartment.department.name }}</span>
                    </b-col>
                    <b-col cols="auto">
                      <button
                        qa="configuration-sections-modal-delete-petitionerDepartment-button"
                        type="button"
                        class="btn btn__icon btn__icon--primary p-0 btn-secondary my-0"
                        @click="deletePetitionerDepartment(petitionerDepartment.id)"
                      >
                        <i
                          class="far fa-times mr-1"
                          aria-hidden="true"
                        />
                      </button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { cloneDeep, isEmpty } from 'lodash'
import ConfigurationCenterServices
    from '@/api/resources/configuration/centersAndAreas/center/ConfigurationCenterServices'
import PetitionerDepartmentConfigurationServices
    from '@/api/resources/configuration/peopleManagement/petitioner/PetitionerDepartmentConfigurationServices'
import ConfigurationDepartmentServices
    from '@/api/resources/configuration/centersAndAreas/department/ConfigurationDepartmentServices'
import { GridUtils } from '@/shared/util/grid-utils'

const DATA_TAB = 0
const DEPARTMENTS_TAB = 1

export default {
    name: 'PetitionerModal',
    props: {
        actionTitle: String
    },
    data() {
        return {
            internalPetitioner: {},
            activeTabIndex: DATA_TAB,
            selectedCenter: null,
            selectedDepartment: null,
            petitionerDepartments: []
        }
    },
    computed: {
        petitionerMainPhone() {
            return this.internalPetitioner.contactInformation.mainPhone
        },
        petitionerEmail() {
            return this.internalPetitioner.contactInformation.email
        },
        modelValidated() {
            const hasErrors = this.$validator.errors.any()
            const isDirty = this.$_someFieldIsDirty(this.fields)
            return !hasErrors && isDirty
        }
    },
    watch: {
        activeTabIndex() {
            if (this.activeTabIndex === DEPARTMENTS_TAB) {
                this.getPetitionerDepartments()
            }
        }
    },
    beforeMount() {
        this.initPetitioner()
    },
    methods: {
        getActions(entity) {
            let actionObj = {}
            if (entity.user) {
                actionObj = { updateUser: { userId: entity.user.id } }
            } else {
                actionObj = { createUser: { petitionerId: entity.id } }
            }
            return actionObj
        },
        async show(selectedPetitioner) {
            await this.$validator.reset()
            this.activeTabIndex = DATA_TAB
            if (selectedPetitioner && !isEmpty(selectedPetitioner)) {
                this.internalPetitioner = cloneDeep(selectedPetitioner)
                if (!this.internalPetitioner.contactInformation) {
                    this.internalPetitioner.contactInformation = {}
                }
            } else {
                this.cleanPetitionerData()
            }
            this.$refs.petitionerModal.show()
            this.$nextTick(() => {
                this.$refs.code.focus()
            })
        },
        hide() {
            this.$refs.petitionerModal.hide()
            this.cleanDepartmentsSelect()
            this.cleanCentersSelect()
        },
        async update() {
            const valid = await this.$validator.validateAll()
            if (valid) {
                if (this.internalPetitioner.id) this.$emit('update', this.internalPetitioner)
                else this.$emit('create', this.internalPetitioner)
            }
        },
        initPetitioner() {
            this.internalPetitioner = {
                active: true,
                code: '',
                contactInformation: {},
                isPhysician: false,
                middleName: null,
                surname1: '',
                surname2: '',
                name: '',
                user: null
            }
        },
        cleanPetitionerData() {
            this.initPetitioner()
        },
        cleanDepartmentsSelect() {
            this.$refs.departmentsSelect.clearInternalOptions()
            this.selectedDepartment = null
        },
        cleanCentersSelect() {
            this.$refs.centersSelect.clearInternalOptions()
            this.selectedCenter = null
        },
        async addPetitionerDepartment() {
            const request = {
                departmentId: this.selectedDepartment.id,
                petitionerId: this.internalPetitioner.id
            }
            this.updateLoading(true)
            const [error] = await this.toCall(PetitionerDepartmentConfigurationServices.createPetitionerDepartment(request))
            this.updateLoading(false)
            if (error) {
                this.showErrorModalGlobalFromErrorResponse(error)
                return
            }
            this.cleanDepartmentsSelect()
            await this.getPetitionerDepartments()
            this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.petitionerDepartmentCreated', 1))
        },
        async deletePetitionerDepartment(petitionerDepartmentId) {
            this.updateLoading(true)
            const [error] = await this.toCall(PetitionerDepartmentConfigurationServices.deletePetitionerDepartment(petitionerDepartmentId))
            this.updateLoading(false)
            if (error) {
                this.showErrorModalGlobalFromErrorResponse(error)
                return
            }
            this.cleanDepartmentsSelect()
            await this.getPetitionerDepartments()
            this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.petitionerDepartmentDeleted', 1))
        },
        async getCenters(query) {
            if (query) {
                const filterModel = {
                    'active': GridUtils.getSetFilterModel(['true']),
                    'name': GridUtils.getTextFilterModel('contains', query)
                }
                const paginator = await ConfigurationCenterServices.paginator(filterModel)
                return paginator.content
            } else {
                return []
            }
        },
        async getPetitionerDepartments() {
            const filterModel = {
                'petitioner.id': GridUtils.getNumberFilterModel('equals', this.internalPetitioner.id)
            }
            this.updateLoading(true)
            const [error, response] = await this.toCall(PetitionerDepartmentConfigurationServices.paginator(filterModel))
            this.updateLoading(false)
            if (error) {
                this.showErrorModalGlobalFromErrorResponse(error)
                return
            }
            this.petitionerDepartments = response.content
        },
        async getDepartmentsByCenter(query) {
            if (query) {
                const filterModel = {
                    'active': GridUtils.getSetFilterModel(['true']),
                    'center.id': GridUtils.getNumberFilterModel('equals', this.selectedCenter && this.selectedCenter.id),
                    'name': GridUtils.getTextFilterModel('contains', query)
                }
                const response = await ConfigurationDepartmentServices.paginator(filterModel)
                return response.content.filter(department => {
                    if (!this.petitionerDepartments.length) {
                        return department
                    } else {
                        return this.petitionerDepartments.find(petitionerDepartment => petitionerDepartment.department.id !== department.id)
                    }
                })
            } else {
                return []
            }
        }
    }
}
</script>

<style lang="scss">
    .petitioner-modal .petitioner-departments-empty-state {
        font-style: italic;
        text-align: center;
    }
    .petitioner-modal .modal-body {
        border-radius: .3rem;
    }
    .petitioner-modal .tab-content {
        height: calc(100vh - 330px);
        overflow-y: auto;
    }
    @media only screen and (max-width: 1366px) and (min-width: 1360px) {
        .petitioner-modal .tab-content {
            height: calc(100vh - 160px);
        }
    }
</style>
